/**
 * Configuration constants for HumioIntegrationProvider
 */

/**
 * Token management configuration constants
 * All timings are optimized for Humio's 24-hour API token lifetime
 */
export const TOKEN_CONFIG = {
  /**
   * Proactive refresh at 22 hours (2-hour buffer before expiry)
   * Accounts for clock skew between client/server and ensures refresh well before expiry
   */
  PROACTIVE_REFRESH_MS: 22 * 60 * 60 * 1000, // 22 hours

  /**
   * Token cache duration for performance optimization
   * Reduces unnecessary API calls for recently validated tokens
   */
  TOKEN_CACHE_DURATION_MS: 60 * 60 * 1000, // 1 hour

  /** Maximum refresh attempts within the rate limit window */
  MAX_REFRESH_ATTEMPTS: 3,

  /** Time window for rate limiting refresh attempts */
  RATE_LIMIT_WINDOW_MS: 60 * 1000, // 1 minute

  /** Maximum retries for dashboard queries on authentication failure */
  MAX_DASHBOARD_RETRIES: 3,

  /** Initial delay for dashboard query retry */
  DASHBOARD_RETRY_DELAY_MS: 100, // 100ms

  /** Delay for downstream service errors (with exponential backoff) */
  DOWNSTREAM_RETRY_DELAY_MS: 500, // 500ms

  /** Minimum time between successive token refreshes */
  MIN_REFRESH_INTERVAL_MS: 5000, // 5 seconds
} as const;

/**
 * Initial state for HumioIntegrationProvider
 */
export const INITIAL_STATE = {
  token: undefined,
  tokenLoading: false,
  tokenError: undefined,
  dashboardsData: undefined,
  dashboardsLoading: false,
  dashboardsError: undefined,
  logScaleURL: undefined,
  logScaleDashboardId: undefined,
  logScaleURLParams: undefined,
  iframeKey: 0,
  eulaAccepted: false,
  humioAccepted: false,
  termsProcessing: false,
} as const;
